/**
 * A way to display a set of images as a slideshow.. one
 * image fading into the next.
 *
 * e.g. multiImg="[{
 *     description: 'A description of what we see',
 *     src: 'https://a/url'
 * }, { ... }]"
 */
angular.module('pitch.app')
.directive('multiImg', function($interval) {
    'use strict';
    return {
        restrict: 'A',
        scope: {
            'images': '=multiImg',
            'width': '=',
            'height': '=',
            'delay': '='
        },
        compile: function(element, attrs) {
            attrs.delay = attrs.delay || '3000';
        },
        controller: function($scope) {
            var rotate;

            if ($scope.images.length > 1) {
                $scope.current = $scope.images[0];

                //then rotate the image
                var index = 0;

                rotate = $interval(function() {
                    index++;
                    index = index < $scope.images.length ? index : 0;
                    $scope.current = $scope.images[index];
                }, $scope.delay);
            } else {
                $scope.current = $scope.images[0];
            }

            $scope.$on('$destroy', function() {
                $interval.cancel(rotate);
            });

        },
        template:   '<div class="thumbnail thumbnail-max-350 thumbnail-opaque multi-img">' +
                        '<img alt="[[::img.alt]]" class="fade-in" ng-show="current == img" ng-repeat="img in ::images" width="[[::width]]" height="[[::height]]" ng-src="[[::img.src]]"></img>' +
                    '</div>'
    };
})

;



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/directives/multiImg.js